import { render, staticRenderFns } from "./CollectionHeader.vue?vue&type=template&id=47eb3070&scoped=true&"
import script from "./CollectionHeader.vue?vue&type=script&lang=ts&"
export * from "./CollectionHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb3070",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkeletonPane: require('/tmp/build_b2fe7c28/components/skeleton-loading/SkeletonPane.vue').default})
